import AcRewardsForm from '../model/form.model';
import AcrewardsModel from '../model/acrewards.model';
import moment from 'moment';

class FormController {
  constructor(AcrewardsStore, FormService, $window, $timeout) {
    'ngInject';

    this.$window = $window;
    this.$timeout = $timeout;
    this.AcrewardsStore = AcrewardsStore;
    this.FormService = FormService;
  }

  $onInit() {
    this.form = new AcRewardsForm();
    this.model = new AcrewardsModel();
  }

  $doCheck() {
    if (this.periods && this.periods.dwlDateFrom && this.periods.dwlDateTo) {
      this.form.periods = this.periods;
      if (this.periods.dwlDateFrom) {
        this.periods.dwlDateFrom = moment(this.periods.dwlDateFrom).format('YYYY-MM-DD');
      }

      if (this.periods.dwlDateTo) {
        this.periods.dwlDateTo = moment(this.periods.dwlDateTo).format('YYYY-MM-DD');
      }

      this.form.dwlDateFrom = this.periods.dwlDateFrom;
      this.form.dwlDateTo = this.periods.dwlDateTo;
      this.form.filterRevenueShare = this.filterRevenueShare;
    }
  }

  submitForm() {
    let order = $('ul#commissionTab').find('li.active').attr('data-order');
    this.form.limit = 10;
    this.form.precision = 2;
    this.form.orderBy = order;
    $('.commissions-table').hide();
    $('.table-loading').show();

    this.FormService.isSubmitting.next(true);
    this.AcrewardsStore.filterAction(this.form.toPayload())
    .then((resp) => {
      $('.commissions-table').show();
      $('.table-loading').hide();
      this.onFiltered({data: resp, total: resp.totals});
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => this.FormService.isSubmitting.next(false))
    ;
  }
}

export default FormController;



// WEBPACK FOOTER //
// ./client/app/pages/acrewards/component/form.controller.js